import { render, staticRenderFns } from "./ListaDeParametros.vue?vue&type=template&id=21c41884&scoped=true&"
import script from "./ListaDeParametros.vue?vue&type=script&lang=ts&"
export * from "./ListaDeParametros.vue?vue&type=script&lang=ts&"
import style0 from "./ListaDeParametros.vue?vue&type=style&index=0&id=21c41884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c41884",
  null
  
)

export default component.exports